var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDisabledOnMobileIcon = function SvgDisabledOnMobileIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 84,
    viewBox: "0 0 139 84",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8V7.5C7.72386 7.5 7.5 7.72386 7.5 8H8ZM8 76H7.5C7.5 76.2761 7.72386 76.5 8 76.5V76ZM131 76V76.5C131.276 76.5 131.5 76.2761 131.5 76H131ZM131 8H131.5C131.5 7.72386 131.276 7.5 131 7.5V8ZM7.5 8V76H8.5V8H7.5ZM8 76.5H131V75.5H8V76.5ZM131.5 76V8H130.5V76H131.5ZM131 7.5H8V8.5H131V7.5Z",
    fill: "#CBCDD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H131",
    stroke: "#CBCDD1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 16V76",
    stroke: "#CBCDD1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 64H31",
    stroke: "#CBCDD1",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 60H20",
    stroke: "#CBCDD1",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 52H31",
    stroke: "#CBCDD1",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11 48H20",
    stroke: "#CBCDD1",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11 40H31",
    stroke: "#CBCDD1",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11 36H20",
    stroke: "#CBCDD1",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11 28H31",
    stroke: "#CBCDD1",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H20",
    stroke: "#CBCDD1",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74 64H120",
    stroke: "#E573A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74 60H120",
    stroke: "#9D62CC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46 52H85",
    stroke: "#E573A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46 48H85",
    stroke: "#9D62CC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M95 39C94.4477 39 94 39.4477 94 40C94 40.5523 94.4477 41 95 41V39ZM95 41H130.5V39H95V41Z",
    fill: "#E573A3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M95 35C94.4477 35 94 35.4477 94 36C94 36.5523 94.4477 37 95 37V35ZM95 37H130.5V35H95V37Z",
    fill: "#9D62CC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M39 28H71",
    stroke: "#E573A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M39 24H71",
    stroke: "#9D62CC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M123 11.5C122.724 11.5 122.5 11.7239 122.5 12C122.5 12.2761 122.724 12.5 123 12.5V11.5ZM123 12.5H130.5V11.5H123V12.5Z",
    fill: "#CBCDD1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M95 12H107",
    stroke: "#CBCDD1",
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M67 12H79",
    stroke: "#CBCDD1",
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M39 12H51",
    stroke: "#CBCDD1",
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12H23",
    stroke: "#CBCDD1",
    strokeLinecap: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDisabledOnMobileIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/disabled-on-mobile-icon.7d054234.svg";
export { ForwardRef as ReactComponent };